module.exports = __webpack_public_path__ + "static/resume-ashleyvanlaer2-2e6b88838b6ec6f3e7a6f18fd74050f8.pdf";